module.exports = __webpack_public_path__ + "static/media/83.74ced949.jpg";